@fl_border: #eceef2;
@fl_text: #475467;
@fl_text_muted: #b7bcc7;
@fl_text_secondary: #667085;
@fl_title: #102442;
@fl_pill_bg: #f9fafb;

.line_icon_smaller {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    flex-shrink: 0;
}

// The "LLM in progress" loader icon spins.
.spin {
    animation: spin 1.2s linear infinite;
}
@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.evalPercentBox {
    background-color: @fl_pill_bg;
    border-radius: 10px;
    padding: 2px 8px;
}
.line_icon {
    width: 49px;
    height: 16px;
    flex-shrink: 0;
}

.eval_row {
    gap: 8px;
}

// Placeholder pill shown until an eval has actually run.
.eval_pending {
    width: 49px;
    height: 16px;
    flex-shrink: 0;
    background-color: @fl_pill_bg;
    border-radius: 100px;
    color: @fl_text_muted;
    font-family: Hanken Grotesk;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
}

// Divider + "Total Score" row that closes the Evaluations card.
.eval_footer {
    border-top: 1px solid @fl_border;
    margin-top: 16px;
    padding-top: 16px;
}
.eval_total_label {
    font-family: Hanken Grotesk;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
    color: @fl_text;
}
.eval_not_started {
    font-family: Hanken Grotesk;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    color: @fl_text_muted;
    background-color: @fl_pill_bg;
    border-radius: 10px;
    padding: 2px 8px;
}
.line_text {
    font-family: Hanken Grotesk;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    color: @fl_text;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    flex: 1 0 0;
}

.line_text_muted {
    color: @fl_text_muted;
}

// Standalone line inside a column card: no row flex sizing, which would
// collapse the height to zero.
.line_text_block {
    .line_text();
    flex: 0 0 auto;
}

.inner_title {
    font-family: Hanken Grotesk;
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    color: @fl_title;
    padding-bottom: 16px;
}
// Positioning context for the side panel's drag handle.
.split_wrap {
    position: relative;
    width: 100%;
    height: 100%;
    min-width: 0;
}

// Keep the resize cursor and kill text selection while a drag is in flight.
.split_dragging {
    cursor: col-resize;
    user-select: none;
}

// Invisible grab strip straddling the seam between panel and chat.
.panel_resize_handle {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 12px;
    z-index: 5;
    cursor: col-resize;
    touch-action: none;
}

// Header / scrolling section list / footer. The panel itself never scrolls —
// only the section list does, so the footer stays pinned.
.round_border_container {
    background-color: #ffffff;
    border: 1px solid #eaecf0;
    border-radius: 12px 0 0 12px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
    overflow: hidden;
}

// The Figma "Section" frame: holds the section cards below the blue header.
.sections_wrap {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    border-top: 1px solid @fl_border;
    padding: 16px 24px 16px 16px;
    gap: 16px;
}

// Shared card style for the panel sections (Pre-work, Work, Evaluations,
// Sources).
.section_card {
    background-color: #ffffff;
    border: 1px solid @fl_border;
    border-radius: 16px;
    padding: 16px;
    width: 100%;
    flex-shrink: 0;
}
.prework_list {
    .section_card();
    gap: 16px;
}
.last_run_line {
    flex-shrink: 0;
    gap: 6px;
    padding: 0 4px 4px;
    font-family: Hanken Grotesk;
    font-size: 12px;
    line-height: 16px;
    color: @fl_text_secondary;

    i {
        font-size: 13px;
    }
    span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.steps_list {
    .section_card();
    gap: 8px;
}

.steps_list_eval {
    .section_card();
    gap: 8px;
}

.sources_list {
    .section_card();
    gap: 16px;
}

.source_row {
    gap: 4px;
}
.source_icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}
// The "+" (Sources) and pencil (Evaluations) actions in the card headers.
.header_action_icon {
    width: 16px;
    height: 16px;
    padding: 2px;
    box-sizing: content-box;
    cursor: pointer;
    flex-shrink: 0;
}
.sources_empty {
    font-family: Hanken Grotesk;
    font-size: 12px;
    color: @fl_text_muted;
}

.back_to_workstreams {
    background-color: #243a5c;
    border-radius: 12px 0 0 0;
    align-items: center;
    gap: 8px;
    padding: 8px 4px 8px 16px;
    width: 100%;
    flex-shrink: 0;
}
.header_title {
    margin-left: 5px;
    flex: 1 0 0;
    min-width: 0;
    color: white;
    font-family: LustTextItalic, serif;
    font-size: 15px;
    // Lust Italic sits high in its line box; nudge the glyph down so it reads
    // optically centered against the back button and kebab.
    line-height: 20px;
    padding-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.back_icon {
    width: 20px;
    height: 20px;
    display: block;
}
.saved_outputs {
    border-top: 2px dashed #d0d5dd;
    padding: 8px 16px;
    flex-shrink: 0;
}
.saved_outputs_label {
    font-family: Hanken Grotesk;
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    color: @fl_text;
}

.is_var_saved {
    font-family: LustTextItalic, serif;
    font-size: 20px;
    background-color: @fl_pill_bg;
    color: #e3e6eb;
    padding: 2px 8px 8px 10px;
    border-radius: 14px;
    cursor: pointer;
    line-height: normal;
}

.back_button {
    position: relative;
    height: 20px;
    width: 20px;
    background-color: #2075f4;
    border-radius: 6px;
    border: none;
    box-shadow: 0 2px 2px rgba(4, 34, 80, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    &:hover {
        background-color: #1864c6;
        transform: scale(1.1);
    }
    &:active {
        background-color: #1e52a1;
        transform: scale(1);
    }
    transition: all 0.2s ease;
    z-index: 10;
}

.dropdownItem {
    font-family: Hanken Grotesk;
    font-size: 14px;
    font-weight: normal;
}
